import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ProgressBar from '../../../utils/progressBar/ProgressBar.js';
import { addVendor } from '../../../redux/api/vendorApi/VendorApi.js';
import { updateVendor } from '../../../redux/api/vendorApi/VendorApi.js';
import { addvendorAction } from '../../../redux/reduxSlice/VendorSlice.js';
import { updatevendorAction } from '../../../redux/reduxSlice/VendorSlice.js';
import Select from 'react-select';
import './Vendor.css'
import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  FormLabel
} from '@chakra-ui/react';


function VendorForm(props) {
  const { isUpdateMode, dataToEdit, formData: initialFormData, setIsUpdateMode, vendorROWID, onNewDataAdded } = props;
  const dispatch = useDispatch();
  const [showProgressBar, setShowProgressBar] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);


  const [formData, setFormData] = useState(
    {
      vendorName: "",
      vendorOwner: "",
      phone: " ",
      email: "",
      wbsite: "",
      grossTurnover: "",
      legalName: "",
      currentFrenchiseReference: "",
      howTheyHearAboutUs: "",
      country: "",
      natureOfBusiness: "",
      anyComments: "",
      anyOtherBuisnessIfAny: "",
      street: "",
      city: "",
      state: "",
      pinCode: "",
      country: "",
      operatingAsA: "",
      discountPercentage: "",
      discountAccountId: "",
      description: "",
    });

  const handleOnClose = () => {
    closeDrawer();
    setIsUpdateMode(false)
    setFormData({
      vendorName: "",
      vendorOwner: "",
      phone: " ",
      email: "",
      wbsite: "",
      grossTurnover: "",
      legalName: "",
      currentFrenchiseReference: "",
      howTheyHearAboutUs: "",
      country: "",
      natureOfBusiness: "",
      anyComments: "",
      anyOtherBuisnessIfAny: "",
      street: "",
      city: "",
      state: "",
      pinCode: "",
      country: "",
      operatingAsA: "",
      discountPercentage: "",
      discountAccountId: "",
      description: "",

    })
  };


  // Handle Submit
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData)
    setShowProgressBar(true)
    addVendor(formData)
      .then((response) => {
        onNewDataAdded()
        console.log("Responseeeeeeeeeeeeeeee - ", response);
        if (response.data.success) {
          const ROWID = response.data.response.ROWID
          dispatch(addvendorAction({ ROWID, formData }));
          setFormData()
          setShowProgressBar(false)
          toast.success("Vendor added successfully!");
          handleOnClose();
          setFormData();
        }
        else {
          toast.error("Unable to add Vendor , Please try again!")
        }
      })
      .catch((error) => {
        console.error("API Error", error);
        setShowProgressBar(false)
        toast.error("Failed to add Vendor. Please try again.");
      });
  }


  // UpdateMode Use-effect
  useEffect(() => {
    console.log(isUpdateMode, dataToEdit)
    if (isUpdateMode && dataToEdit) {
      setFormData((prev) => ({
        ...prev, ...props.dataToEdit,
      }
      ))
    }
    console.log(formData)
  }, [isUpdateMode, dataToEdit]);

  useEffect(() => {
    console.log(formData)
  }, [formData])


  // Handle Update Function
  const handelOnUpdate = (e) => {
    e.preventDefault()
    setShowProgressBar(true)
    updateVendor(formData).then((response) => {
      console.log({ response })
      if (response.data.success) {
        setFormData((prev) => ({
          ...prev, ROWID: response?.data.ROWID
        }))
        dispatch(updatevendorAction(formData))
        toast.success("Vendor Updated SuccesFully !!")
        setShowProgressBar(false);
      }
      setTimeout(() => {
        handleOnClose();
        setShowProgressBar(false);
        setSubmitDisabled(false)
      }, 300);
    }).catch((error) => {
      console.log(error)
      toast.error("Vendor Updation Failed !")
      setShowProgressBar(false);

    }).finally(() => {
      setSubmitDisabled(false);
      setShowProgressBar(false);
    });
  }

  const countries = [
    "Afghanistan",
    "Albania",
    "Algeria",
    "Andorra",
    "Angola",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bhutan",
    "Bolivia",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "Brunei",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cabo Verde",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Colombia",
    "Comoros",
    "Congo",
    "Costa Rica",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Democratic Republic of the Congo",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "East Timor",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Eswatini",
    "Ethiopia",
    "Fiji",
    "Finland",
    "France",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Greece",
    "Grenada",
    "Guatemala",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Honduras",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran",
    "Iraq",
    "Ireland",
    "Israel",
    "Italy",
    "Ivory Coast",
    "Jamaica",
    "Japan",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Kosovo",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Mauritania",
    "Mauritius",
    "Mexico",
    "Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "North Korea",
    "North Macedonia",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestine",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Korea",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Sweden",
    "Switzerland",
    "Syria",
    "Taiwan",
    "Tajikistan",
    "Tanzania",
    "Thailand",
    "Togo",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Vatican City",
    "Venezuela",
    "Vietnam",
    "Yemen",
    "Zambia",
    "Zimbabwe"
  ];
  // Custom style for lookup field
  const customStyle = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? 'silver' : 'rgb(93, 135, 255)',
      borderRadius: "20px",
      border: '0.5px solid rgb(196,196,196,0.5) !important'
    }),
    placeholder: (styles) => ({
      ...styles,
      color: 'gray',
    }),
    singleValue: (styles, { data }) => ({
      ...styles,
      color: 'black',
      backgroundColor: 'white',
    }),
    option: (styles, { isSelected, isFocused }) => ({
      ...styles,
      backgroundColor: isSelected
        ? '#f1e9e9;'
        : isFocused
          ? '#f1e9e9;'
          : 'white',
      color: isSelected ? '#666' : '#333',
    }),
  }
  const [vendorOwner, setVendorOwner] = useState([])
  const { closeDrawer } = props;

  // Handle Change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };
  // Handle Submit
  // const handleSubmit = () => {
  //   console.log("Form Submitted with data:", formData);
  //   closeDrawer();
  // };
  return (
    <>
      <Drawer
        isOpen={props.isDrawerOpen}
        placement='right'
        size='xl'
        onClose={handleOnClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader> {isUpdateMode ? "Update Vendor Form" : "Create Vendor Form"}</DrawerHeader>
          <DrawerBody>
            {showProgressBar && <ProgressBar colorScheme='pink' />}
            <form onSubmit={isUpdateMode ? handelOnUpdate : handleSubmit}>
              <div className='row '>
                <div className='card'>
                  <div className='card-body'>
                    <legend style={{ fontSize: 'Large' }} className='sub-headers' >Vendor Information</legend>
                    <div className='row mt-3 mb-2'>
                      <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <Select name='vendorOwner' options={vendorOwner} defaultValue={vendorOwner.find((item) => (item.value === formData?.vendorOwner))} onChange={(option) => { setFormData(prevFormData => ({ ...prevFormData, vendorOwner: option.value })) }} styles={customStyle} />
                        <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Vendor Owner</FormLabel>
                      </div>
                      <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                          <input type='text' style={{ outline: "none", border: "none" }} placeholder='Vendor Name' name='vendorName' value={formData?.vendorName} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Vendor Name</FormLabel>
                      </div>
                    </div>
                    <div className='row '>
                      <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                          <input type='number' style={{ outline: "none", border: "none" }} placeholder='Phone' name='phone' value={formData?.phone} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3" style={{ paddingLeft: "2px" }}>Phone</FormLabel>
                      </div>
                      <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                          <input type='email' style={{ outline: "none", border: "none" }} placeholder='Email' name='email' value={formData?.email} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Email</FormLabel>
                      </div>
                    </div>
                    <div className='row '>
                      <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                        <div className='search-by-title'>
                          <input type='url' style={{ outline: "none", border: "none" }} placeholder='Website' name='wbsite' value={formData?.wbsite} onChange={handleChange} />
                        </div>
                        <FormLabel className="small-label ps-3">Website</FormLabel>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='card mt-2'>
                <div className='card-body'>
                  <legend style={{ fontSize: 'Large' }} className='sub-headers' >Franchisee Details</legend>
                  <div className='row '>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <select name='grossTurnover' type='text' placeholder="Gross turnover" style={{ width: '100%', outline: "none" }} value={formData?.grossTurnover} onChange={handleChange}  >
                          <option value="None">None</option>
                          <option value="$30K">$30K</option>
                          <option value="$50K">$50K</option>
                          <option value="$75K">$75K</option>
                          <option value="$100K">$100K</option>
                          <option value="$150K">$150K</option>
                        </select>
                      </div>
                      <FormLabel className="small-label ps-3" style={{ paddingLeft: "6px" }}>Gross turnover</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input type='text' style={{ outline: "none", border: "none" }} placeholder='Legal Name' name='legalName' value={formData?.legalName} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Legal Name</FormLabel>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input type='text' style={{ outline: "none", border: "none" }} placeholder='Current frenchise reference' name='currentFrenchiseReference' value={formData?.currentFrenchiseReference} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Current frenchise reference</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <select name='howTheyHearAboutUs' type='text' placeholder="How they hear about us" style={{ width: '100%', outline: "none" }} value={formData?.howTheyHearAboutUs} onChange={handleChange}  >
                          <option value="None">None</option>
                          <option value="Customer">Customer</option>
                          <option value="Advertisement">Advertisement</option>
                          <option value="Referral">Referral</option>
                          <option value="Email">Email</option>
                          <option value="Trade Show">Trade Show</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                      <FormLabel className="small-label ps-3" >How they hear about us</FormLabel>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <select type='text' name='operatingAsA' placeholder="Operatingasa" style={{ width: '100%', outline: "none" }} value={formData?.operatingAsA} onChange={handleChange}  >
                          <option value="None">None</option>
                          <option value="Part time owner operator">Part time owner operator</option>
                          <option value="Full time owner operator">Full time owner operator</option>
                          <option value="Full time owner and employee operating">Full time owner and employee operating</option>
                        </select>
                      </div>
                      <FormLabel className="small-label ps-3" >Operating as a</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <div className='search-by-title'>
                        <input type='text' style={{ outline: "none", border: "none" }} placeholder='Nature of Business' name='natureOfBusiness' value={formData?.natureOfBusiness} onChange={handleChange} />
                      </div>
                      <FormLabel className="small-label ps-3">Nature of Business</FormLabel>
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <textarea className='form-control ' rows='3' placeholder='Any Comments' name='anyComments' value={formData?.anyComments} onChange={handleChange} >
                      </textarea>
                      <FormLabel className="small-label ps-3">Any Comments</FormLabel>
                    </div>
                    <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                      <textarea className='form-control ' rows='3' placeholder='Any other buisness (if any)' name='anyOtherBuisnessIfAny' value={formData?.anyOtherBuisnessIfAny} onChange={handleChange} >
                      </textarea>
                      <FormLabel className="small-label ps-3">Any other buisness (if any)</FormLabel>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <fieldset>
                  <div className='card mt-2'>
                    <div className='card-body'>
                      <legend style={{ fontSize: 'Large' }} className='sub-headers'>Address Information</legend>
                      <div className='row'>
                        <div className='col-lg-8 col-md-4 col-sm-12 mb-2'>
                          <input className='form-control input-field' type='text' placeholder='street' name="street" value={formData?.street} onChange={handleChange} />
                          <FormLabel className="small-label ps-3">Street</FormLabel>
                        </div>
                        <div className='col-lg-4 col-md-4 col-sm-12 mb-2'>
                          <input className='form-control input-field' type='text' placeholder='city' name="city" value={formData?.city} onChange={handleChange} />
                          <FormLabel className="small-label ps-3">City</FormLabel>
                        </div>
                        <div className='col-lg-4 col-md-4 col-sm-12 mb-2'>
                          <input className='form-control input-field' type='text' placeholder='state' name="state" value={formData?.state} onChange={handleChange} />
                          <FormLabel className="small-label ps-3">State</FormLabel>
                        </div>
                        <div className='col-lg-4 col-md-4 col-sm-12 mb-2'>
                          <input className='form-control input-field' type='text' placeholder='pinCode' name="pinCode" value={formData?.pinCode} onChange={handleChange} />
                          <FormLabel className="small-label ps-3">PinCode</FormLabel>
                        </div>
                        <div className='col-lg-4 col-md-4 col-sm-12 mb-2'>
                          <select className='form-select input-field' name="country" value={formData?.country} onChange={handleChange}  >
                            <option value="">Select Country</option>
                            {countries?.map((country, index) => (
                              <option key={index} value={country}>
                                {country}
                              </option>
                            ))}
                          </select>
                          <FormLabel className="small-label ps-3">Country</FormLabel>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>
              <div>

              </div>
            </form>

            <div className='card mt-2'>
              <div className='card-body'>
                <legend style={{ fontSize: 'medium' }} className='sub-headers'>Description Information</legend>
                <div className='row mt-4'>

                  <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                    <div className='search-by-title'>
                      <input className='rounded' type='percentage' style={{ outline: "none", border: "none" }} placeholder='Discount Percentage' name='discountPercentage' value={formData?.discountPercentage} onChange={handleChange} />
                    </div>
                    <FormLabel className="small-label ps-3">Discount Percentage</FormLabel>
                  </div>
                  <div className='col-lg-6 col-md-6 col-sm-12 mb-2'>
                    <div className='search-by-title'>
                      <input className='rounded' type='text' style={{ outline: "none", border: "none" }} placeholder='Discount Account Id' name='discountAccountId' value={formData?.discountAccountId} onChange={handleChange} />
                    </div>
                    <FormLabel className="small-label ps-3">Discount Account Id</FormLabel>
                  </div>
                </div>
                <div className='row '>
                  <div className='col-lg-12 col-md-6 col-sm-12 mb-2'>
                    <textarea className='form-control rounded' rows='4' placeholder='description' name='description' value={formData?.description} onChange={handleChange} >
                    </textarea>
                    <FormLabel className="small-label ps-3">Description</FormLabel>
                  </div>
                </div>
              </div>
            </div>

          </DrawerBody>
          <center><DrawerFooter style={{ display: 'inline-block' }}>
            <div className='gap-3 d-flex'>
              <button variant='outline' mr={3} onClick={handleOnClose} className="cancel-button">
                Cancel
              </button>
              <button className='create-button' onClick={(e) => { !isUpdateMode ? handleSubmit(e) : handelOnUpdate(e) }} >{isUpdateMode ? "Update" : "Submit"}</button>
            </div>
          </DrawerFooter></center>
        </DrawerContent>
      </Drawer>
    </>
  )
}
export default VendorForm;